import React from "react";

// The real Sharkbowl brand mark (bowl + fin + waves + saucer), no text.
// variant "white" renders it pure white for dark/transparent backgrounds;
// "dark" keeps the original black mark for light backgrounds.
export default function BrandLogo({ className = "", variant = "white" }) {
  const filter = variant === "white" ? "brightness(0) invert(1)" : "none";
  return (
    <img
      src="/sharkbowl-logo.png"
      alt="Sharkbowl Games"
      className={className}
      style={{ filter, objectFit: "contain" }}
      draggable={false}
    />
  );
}
